module.exports = require("./xh.d.ts");